import { get, put } from './client';

/**
 * @param {boolean} [apenasNaoLidas]
 * @param {number|null} [candidatoId]
 */
export const listarNotificacoes = (apenasNaoLidas = false, candidatoId = null) => {
  const params = new URLSearchParams();
  if (apenasNaoLidas) params.append('apenas_nao_lidas', '1');
  if (candidatoId) params.append('candidato_id', String(candidatoId));
  const q = params.toString();
  return get(`/notificacoes${q ? `?${q}` : ''}`);
};

/**
 * @param {number|null} [candidatoId]
 */
export const contarNotificacoesNaoLidas = (candidatoId = null) => {
  const q = candidatoId ? `?candidato_id=${candidatoId}` : '';
  return get(`/notificacoes/contagem${q}`);
};

export const marcarNotificacaoLida = (id) => put(`/notificacoes/${id}/lida`);

/**
 * @param {number|null} [candidatoId]
 */
export const marcarTodasNotificacoesLidas = (candidatoId = null) => {
  const q = candidatoId ? `?candidato_id=${candidatoId}` : '';
  return put(`/notificacoes/marcar-todas-lidas${q}`);
};


